export const Auth0ConnectionEnum = {
  UsernamePassword: 'Username-Password-Authentication',
  Facebook: 'facebook',
};

/**
 * Returns the URL to log in
 */
export function getLoginUrl(opts?: { returnTo?: string; connection?: string }) {
  if (typeof window === 'undefined') return;
  const search = new URLSearchParams();
  search.append('returnTo', opts?.returnTo || window.location.href);
  if (opts?.connection) search.append('connection', opts.connection);
  return `/api/auth?${search.toString()}`;
}

/**
 * Returns the URL to log out
 */
export function getLogoutUrl() {
  if (typeof window === 'undefined') return;
  return `/api/auth/logout?returnTo=${window.location.href}`;
}

/**
 * Fetches user information if authenticated
 */
export async function getMe() {
  try {
    const res = await fetch('/api/auth/me');
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    return null;
  }
}
